import { render, staticRenderFns } from "./ServicePreview.vue?vue&type=template&id=84f30b00&scoped=true"
import script from "./ServicePreview.vue?vue&type=script&lang=js"
export * from "./ServicePreview.vue?vue&type=script&lang=js"
import style0 from "./ServicePreview.vue?vue&type=style&index=0&id=84f30b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f30b00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
